import { useState, useEffect, useRef } from 'react';

import CountdownTimer from "react-component-countdown-timer";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import classes from '../../App.module.scss';
import { finishExam } from '../../assets/api/userActions';


const CountDown = ({ timeRemained, totalTime, attemptID }) => {

    const navigate = useNavigate();
    const expireHandled = useRef(false);

    const [timeLeft, setTimeLeft] = useState(
        timeRemained === "finished" ? 0 : timeRemained
    );
    const [totalTimeState] = useState(totalTime);
    const [percentage, setPercentage] = useState(75);

    const handleExpire = async () => {
        if (expireHandled.current || !attemptID) {
            return;
        }
        expireHandled.current = true;

        const res = await finishExam(attemptID);
        if (res?.status === "success-finish") {
            navigate("/quiz/finish");
            return;
        }

        Swal.fire({
            icon: "error",
            title: `${res?.message || "امکان اتمام آزمون نیست"}`,
        });
    };

    useEffect(() => {
        if (timeRemained === "finished") {
            setTimeLeft(0);
            return;
        }
        if (typeof timeRemained === "number" && timeRemained >= 0) {
            setTimeLeft(timeRemained);
        }
    }, [timeRemained]);

    useEffect(() => {
        if (timeRemained === "finished" || timeLeft === 0) {
            handleExpire();
        }
    }, [timeRemained, timeLeft, attemptID]);

    useEffect(() => {
        if (!timeLeft || timeLeft <= 0) return;

        const intervalId = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) return 0;
                return prev - 1;
            });
        }, 1000);
        setPercentage(Math.floor((timeLeft / totalTimeState) * 75));

        return () => clearInterval(intervalId);
    }, [timeLeft, totalTimeState]);

    if (timeRemained === "finished" || timeLeft === 0) {
        return (
            <div className={classes.countdownContainer}>
                <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                    <linearGradient id={"gradient"}>
                        <stop id={classes.stop1} offset="0%" />
                        <stop id={classes.stop2} offset="100%" />
                    </linearGradient>
                    <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                    <circle id={classes.circle_container__progress} strokeDasharray={`0 100`} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                </svg>
                <div className={classes.timeRemained} style={{ zIndex: "1" }}>
                    <div id={classes.time}>00:00:00</div>
                    <div>مانده</div>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.countdownContainer}>
            <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                <linearGradient id={"gradient"}>
                    <stop id={classes.stop1} offset="0%" />
                    <stop id={classes.stop2} offset="100%" />
                </linearGradient>
                <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                <circle id={classes.circle_container__progress} strokeDasharray={`${percentage} 100`} r="16" cx="16" cy="16" shapeRendering="geometricPrecision">
                </circle>
            </svg>
            <div className={classes.timeRemained} style={{ zIndex: "1" }}>
                <div id={classes.time}>
                    <CountdownTimer count={timeLeft} hideDay={true} backgroundColor={"transparent"} size={12} onEnd={handleExpire} />
                </div>
                <div>مانده</div>
            </div>
        </div>
    )
}

const PreviewCountdown = (props) => {

    // const [timeLeft, setTimeLeft] = useState(props.timeRemained);
    function toTimeString(totalSeconds) {
        const totalMs = totalSeconds * 1000;
        const result = new Date(totalMs).toISOString().slice(11, 19);
        return result;
    }

    return (
        <div className={classes.countdownContainer}>
            <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                <linearGradient id={"gradient"}>
                    <stop id={classes.stop1} offset="0%" />
                    <stop id={classes.stop2} offset="100%" />
                </linearGradient>
                <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                <circle id={classes.circle_container__progress} strokeDasharray={`75 100`} r="16" cx="16" cy="16" shapeRendering="geometricPrecision">
                </circle>
            </svg>
            <div className={classes.timeRemained} style={{ zIndex: "1" }}>
                <div id={classes.time}>
                    {toTimeString(props.totalTime)}
                </div>
                <div>مانده</div>
            </div>
        </div>
    )
}

/**
 * شمارنده برای صفحه اطلاعات آزمون (join page)
 * - قبل از شروع آزمون: نمایش نمی‌شود
 * - بعد از شروع: اگر ترک آزمون خاموش بود و کاربر برگشته، شمارنده کار می‌کند
 * - اگر ترک آزمون روشن بود و کاربر ترک کرده: شمارنده متوقف (فقط نمایش مقدار فعلی)
 */
const ExamInfoCountdown = ({ currentAttempt, examData }) => {
    const [timeLeft, setTimeLeft] = useState(null);
    const [totalTime, setTotalTime] = useState(null);
    const [percentage, setPercentage] = useState(75);

    const timer = currentAttempt?.timer;
    const total = currentAttempt?.total_time;
    const duration = currentAttempt?.duration ?? 0;
    /* متوقف وقتی: ترک آزمون فعال + کاربر ترک کرده (broke_at) + (هنوز برنگشته یا دوباره ترک کرده) */
    const isPaused = examData?.leave && currentAttempt?.broke_at && (
        !currentAttempt?.restart_at ||
        (currentAttempt.restart_at && new Date(currentAttempt.broke_at) > new Date(currentAttempt.restart_at))
    );

    /* بعد از ترک آزمون: زمان باقی‌مانده از duration محاسبه می‌شود (total - duration) نه از timer */
    const effectiveTimer = isPaused && total && typeof duration === "number"
        ? Math.max(0, (total - duration))
        : timer;

    useEffect(() => {
        if (effectiveTimer === "unlimited" || effectiveTimer === "finished" || typeof effectiveTimer !== "number") return;
        setTimeLeft(effectiveTimer);
        setTotalTime(total || effectiveTimer);
    }, [effectiveTimer, total]);

    useEffect(() => {
        if (isPaused || !timeLeft || timeLeft <= 0) return;
        const intervalId = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) return 0;
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeLeft, isPaused]);

    useEffect(() => {
        if (timeLeft != null && totalTime && totalTime > 0) {
            setPercentage(Math.floor((timeLeft / totalTime) * 75));
        }
    }, [timeLeft, totalTime]);

    const toTimeString = (totalSeconds) => {
        if (totalSeconds == null || totalSeconds < 0) return "00:00:00";
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = Math.floor(totalSeconds % 60);
        return [h, m, s].map(v => String(v).padStart(2, "0")).join(":");
    };

    if (!currentAttempt) return null;
    if (effectiveTimer === "unlimited") {
        return (
            <div className={classes.countdownContainer}>
                <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                    <linearGradient id={"gradient"}>
                        <stop id={classes.stop1} offset="0%" />
                        <stop id={classes.stop2} offset="100%" />
                    </linearGradient>
                    <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                    <circle id={classes.circle_container__progress} strokeDasharray={`75 100`} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                </svg>
                <div className={classes.timeRemained} style={{ zIndex: "1" }}>
                    <div id={classes.time}>نامحدود</div>
                    <div>مانده</div>
                </div>
            </div>
        );
    }
    if (effectiveTimer === "finished" || timeLeft === 0) {
        return (
            <div className={classes.countdownContainer}>
                <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                    <linearGradient id={"gradient"}>
                        <stop id={classes.stop1} offset="0%" />
                        <stop id={classes.stop2} offset="100%" />
                    </linearGradient>
                    <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                    <circle id={classes.circle_container__progress} strokeDasharray={`0 100`} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                </svg>
                <div className={classes.timeRemained} style={{ zIndex: "1" }}>
                    <div id={classes.time}>00:00:00</div>
                    <div>مانده</div>
                </div>
            </div>
        );
    }
    if (typeof effectiveTimer !== "number") return null;

    const displayTime = timeLeft != null ? timeLeft : timer;

    return (
        <div className={classes.countdownContainer}>
            <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                <linearGradient id={"gradient"}>
                    <stop id={classes.stop1} offset="0%" />
                    <stop id={classes.stop2} offset="100%" />
                </linearGradient>
                <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                <circle id={classes.circle_container__progress} strokeDasharray={`${percentage} 100`} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
            </svg>
            <div className={classes.timeRemained} style={{ zIndex: "1" }}>
                <div id={classes.time}>{toTimeString(displayTime)}</div>
                <div>مانده</div>
                {isPaused && <div style={{ fontSize: 10, color: "#9C9C9C", marginTop: 2 }}>متوقف</div>}
            </div>
        </div>
    );
};

export default CountDown
export { PreviewCountdown, ExamInfoCountdown }
